/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.productGroup", {
        opts: {},

        _setOption: function (key, value) {
            var plgn = this;
            plgn.opts[key] = value;
        },

        getOption: function (opt) {
            var plgn = this;
            return plgn.opts[opt];
        },

        _create: function () {
            this.wrap = this.element;

            this.panel = this.wrap.find(".b-info-panel");
            this.aside = this.panel.parent();

            this.positionPanel();

            $(document).on("window-resized", () => {
                this.positionPanel();
                this.pointEventLayer();
            });

            $(window).on("scroll", () => {
                setTimeout(() => {
                    if (api.vars.windW > api.vars.scr.desktop) {
                        this.positionPanel();
                        this.pointEventLayer();
                    }

                    this.stickyBox();
                });
            });

            jQuery(document.body).on("accordion-activated", () => {
                if(this.panel.hasClass('in-bottom')){
                    this.panel.trigger("sticky_kit:detach");
                    this.panel.removeAttr("style").removeClass('in-bottom').removeClass('is_stuck')

                    setTimeout(() => {
                        this.stickyBox();
                    })
                }
            });

            this.stickyBox();
        },

        stickyBox() {
            if (api.vars.windW > api.vars.scr.desktop) {
                this.panel
                    .stick_in_parent({
                        offset_top: 140,
                        parent: this.wrap,
                        //recalc_every: 500,
                    })
                    .on("sticky_kit:bottom", (e) => {
                        this.panel.addClass("in-bottom");
                    })
                    .on("sticky_kit:unbottom", (e) => {
                        this.panel.removeClass("in-bottom");
                    })
                    .on("sticky_kit:stick", (e) => {
                        this.positionPanel();
                    })
                    .on("sticky_kit:unstick", (e) => {
                        this.positionPanel();
                    });
                setTimeout(() => {
                    this.pointEventLayer();
                });
            } else {
                this.panel.trigger("sticky_kit:detach");
            }
        },

        positionPanel() {
            var hasAside = this.wrap.find(".g-product-group__aside").length;

            if (api.vars.windW > api.vars.scr.desktop && hasAside) {
                this.panel.css({
                    left: this.aside.offset().left,
                    width: this.aside.width(),
                });
            }
        },

        pointEventLayer() {
            this.panel.next().css("pointer-events", "none");
        },
    });
})(jQuery);
